import { outlinedInputClasses, TextFieldProps } from '@mui/material';
import { type Theme } from '@mui/material/styles';

declare module '@mui/material/InputBase' {
  interface InputBasePropsSizeOverrides {
    xsmall: true;
    large: true;
  }
  interface TextFieldPropsSizeOverrides {
    xsmall: true;
    large: true;
  }
}

declare module '@mui/material/TextField' {
  interface TextFieldPropsSizeOverrides {
    xsmall: true;
    large: true;
  }
}

export {};

export default function OutlinedInput(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  const color = {
    focused: theme.palette.primary[400],
    active: theme.palette.text.secondary,
    placeholder: theme.palette.text.disabled,
    error: theme.palette.error[500],
  };

  const font = {
    label: theme.typography.body1,
    value: theme.typography.body2,
  };

  const rootStyles = (ownerState: TextFieldProps) => {
    const xsmallSize = ownerState.size === 'xsmall';
    const smallSize = ownerState.size === 'small';
    const mediumSize = ownerState.size === 'medium';
    const largeSize = ownerState.size === 'large';

    const { disabled } = ownerState;
    const { error } = ownerState;
    const { focused } = ownerState;

    return {
      padding: xsmallSize
        ? theme.spacing(0.5, 1)
        : smallSize
        ? theme.spacing(1)
        : mediumSize
        ? theme.spacing(1, 2)
        : largeSize
        ? theme.spacing(1, 2)
        : theme.spacing(1, 2),
      fontSize: xsmallSize
        ? 12
        : smallSize
        ? 14
        : mediumSize
        ? 16
        : largeSize
        ? 16
        : 16,
      color: theme.palette.grey[600],
      // borderWidth: 1,
      // borderStyle: 'solid',
      // borderColor: theme.palette.grey[300],
      border: 'none',
      boxShadow: `0 0 0 1px ${theme.palette.grey[300]}`,
      borderRadius: xsmallSize
        ? theme.spacing(0.5)
        : smallSize
        ? theme.spacing(0.5)
        : mediumSize
        ? theme.spacing(1)
        : largeSize
        ? theme.spacing(1)
        : theme.spacing(1),
      gap: theme.spacing(0.5),
      ...(disabled && {
        backgroundColor: theme.palette.action.disabledBackground,
        border: 'none',
        boxShadow: `0 0 0 1px ${theme.palette.grey[300]}!important`,
      }),
      ...(error && {
        borderColor: theme.palette.error[500],
      }),
      ...(error &&
        focused && {
          boxShadow: `0 0 0 1px ${theme.palette.error[500]}!important`,
        }),
      ...(!error &&
        focused && {
          // borderColor: color.focused,
          boxShadow: `0 0 0 1px ${color.focused}!important`,
        }),

      [`& > .MuiInputAdornment-root`]: {
        margin: 0,
      },

      '& > input': {
        padding: 0,
        // lineHeight: 1,
        height: 'auto',
        lineHeight: xsmallSize
          ? theme.spacing(2)
          : smallSize
          ? theme.spacing(2)
          : mediumSize
          ? theme.spacing(3)
          : largeSize
          ? theme.spacing(4)
          : theme.spacing(2),
      },
      '& > input::placeholder': {
        color: `${theme.palette.grey[400]}!important`,
      },
    };
  };

  return {
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: TextFieldProps }) => ({
          ...rootStyles(ownerState),
          [`&.${outlinedInputClasses.focused}`]: {
            [`& .${outlinedInputClasses.notchedOutline}`]: {
              // borderColor: color.focused,
              border: 'none',
              boxShadow: `0 0 0 1px ${color.focused}!important`,
              display: 'none',
            },
          },
          [`&.${outlinedInputClasses.error}`]: {
            [`& .${outlinedInputClasses.notchedOutline}`]: {
              // borderColor: theme.palette.error[500],
              border: 'none',
              boxShadow: `0 0 0 1px ${theme.palette.error[500]}!important`,
            },
          },
          [`&.${outlinedInputClasses.disabled}`]: {
            [`& .${outlinedInputClasses.notchedOutline}`]: {
              // borderColor: theme.palette.action.disabledBackground,
              border: 'none',
              boxShadow: `0 0 0 1px ${theme.palette.action.disabledBackground}!important`,
            },
          },
        }),
        notchedOutline: {
          display: 'none',
          // borderColor: color.focused,
          border: 'none',
          boxShadow: `0 0 0 1px ${color.focused}!important`,

          /* borderColor: alpha(theme.palette.grey[500], 0.2),
          transition: theme.transitions.create(['border-color'], {
            duration: theme.transitions.duration.shortest,
          }), */
        },
      },
    },
  };
}
